import React from 'react';
import { BadgeContainer, IconContainer } from './styles';

interface BadgeProps {
  text: string | number;
  width: string | number;
  height: string | number;
  color?: string;
  icon?: React.ReactNode;
  maxCount?: number;
  mobileSize?: string;
  offsetTop?: string;
  offsetRight?: string;
  fontWeight?: number;
  lineHeight?: string;
  fontSize?: number;
}

const Badge: React.FC<BadgeProps> = ({ text, color = '#dd3636', icon, maxCount = 99, width='24px', height='24px', mobileSize, offsetTop, offsetRight, fontWeight, lineHeight, fontSize}) => {
  const displayText = typeof text === 'number' && text > maxCount ? `${maxCount}+` : text;
  const fz = fontSize ?? (typeof text === 'number' && text < 11 ? 11 : 10)
  return (
    <BadgeContainer
      $color={color}
      $fz={fz}
      $width={width}
      $height={height}
      $mobileSize={mobileSize}
      $offsetTop={offsetTop}
      $offsetRight={offsetRight}
      $fontWeight={fontWeight}
      $lineHeight={lineHeight}
    >
      {icon && <IconContainer>{icon}</IconContainer>}
      {displayText}
    </BadgeContainer>
  );
};

export { Badge };